import { ContactPageTypes,  MetaTagsProps} from "@/types";
import {BUSINESS_NAME, OG_PATH, WEBSITE_URL} from "@/content";

export const metaTagsContact : MetaTagsProps = {
    title: `Contact Us - ${BUSINESS_NAME}`,
    description: `Contact ${BUSINESS_NAME} today for expert formwork, concreting, excavation, and structural services in Sydney. Get a free quote from our experienced team.`,
    keywords: "contact formwork Sydney, concreting contact Sydney, excavation services Sydney, get a quote formwork Sydney, structural contractors Sydney",
    url: `${WEBSITE_URL}/contact`,
    ogImage: `${OG_PATH}img1.jpg`,
    type: "website",
}

export const contactPageContent : ContactPageTypes = {
    title: `Contact Us | ${BUSINESS_NAME} Sydney`,
    description: `Get in touch with ${BUSINESS_NAME} for all your concrete formwork, excavation, and structural construction needs in Sydney. Our friendly team is ready to provide expert advice, tailored quotes, and reliable project support.`,
    images: [],
}


